module.exports = __webpack_public_path__ + "static/media/IndWorkOp.6277ed59.png";